// extracted by mini-css-extract-plugin
module.exports = {"title":"LayoutWrapperServiceSideNav_title__1e8xv","tabNav":"LayoutWrapperServiceSideNav_tabNav__2pJLb","tab":"LayoutWrapperServiceSideNav_tab__3T3Sn"};